export const NOT_ENROLLED_COHORT = 'not-enrolled';

export const RECENT_DOWNGRADE_DISCOUNT_TEMPLATE_ID = 'recent-downgrade-discount';
export const RECENT_DOWNGRADE_DISCOUNT_EXPERIMENT = 'recent-churn-discount-experiment';
export const ROVO_EXTENSION_CTA_TEMPLATE_ID = 'rovo-extension-install-cta-left-nav';
